/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
import React from 'react';
import { MapTo, Container } from '@adobe/aem-react-editable-components';
import '../../libs/aemComponents/Container';
import '../../libs/aemComponents/ExperienceFragment';
import {
  EditableHTLWrapper,
  // CardCarouselContainer,
  StaticWrapper,
  CardLayered,
  NavigationContainerWrapper,
  NavigationUtilityLinkWrapper,
  NavigationWrapper,
  Footer,
} from '@marriott/mi-common-static-components';
import {
  ConnectContainerEditable,
  JoinBannerExperienceEditable,
  BonvoyApplicationAdEditable,
  LocalHeaderEditable,
  HeroBannerEditable,
  InternetBarEditable,
  AccuWeatherEditable,
  PropertyPortalContainerEditable,
  LocalServicesEditable,
  LetsConnectEditable,
  MMNComponentEditable,
  TermsOfUseEditable,
} from '@marriott/mi-ppv5-components';
import { OfferCardCarousel } from '@marriott/mi-offers-components';
import { respGridUtil } from '@marriott/mi-headless-utils';
import { Text, Heading } from '@marriott/mi-ui-library';

export const AEM_REACT_MAPPING = {
  [`mi-aem-common-spa/components/common/staticwrapper`]: StaticWrapper,
  [`mi-aem-ppv5-spa/components/content/localheader`]: LocalHeaderEditable,
  [`mi-aem-ppv5-spa/components/content/hero-banner`]: HeroBannerEditable,
  [`mi-aem-common-spa/components/experiencefragment`]: Container,
  [`mi-aem-common-spa/components/experiencefragment`]: Container,
  ['mi-aem-ppv5-spa/components/content/experiencefragment']: Container,
  [`mi-aem-ppv5-spa/components/common/staticwrapper`]: ConnectContainerEditable,
  [`mi-aem-ppv5-spa/components/content/internet-box`]: InternetBarEditable,
  [`mi-aem-ppv5-spa/components/content/accuWeather`]: AccuWeatherEditable,
  [`mi-aem-ppv5-spa/components/content/brandedcontainer`]: PropertyPortalContainerEditable,
  [`mi-aem-ppv5-spa/components/content/services-carousel`]: LocalServicesEditable,
  [`mi-aem-ppv5-spa/components/content/lets-connect-modal`]: LetsConnectEditable,
  [`mi-aem-ppv5-spa/components/content/ppv5-rte`]: TermsOfUseEditable,
  [`mi-aem-offers-spa/components/offers-cards`]: OfferCardCarousel,
  [`mi-aem-homepage-spa/components/content/universal-footer`]: Footer,
  [`mi-aem-common-spa/components/content/mmn-container`]: MMNComponentEditable,
  [`mi-aem-common-spa/components/content/bannerlayerer`]: JoinBannerExperienceEditable,
  [`mi-aem-common-spa/components/text`]: Text,
  [`mi-aem-common-spa/components/title`]: Heading,
  // [`mi-aem-common-spa/components/content/cardcarouselcontainer`]: CardCarouselContainer,
  [`mi-aem-common-spa/components/content/bannerlayered`]: JoinBannerExperienceEditable,
  [`mi-aem-common-spa/components/content/cardhorizontalmini`]: BonvoyApplicationAdEditable,
  [`mi-aem-common-spa/components/content/cardlayered`]: CardLayered,
  [`mi-aem-homepage-spa/components/content/global-navigation`]: NavigationContainerWrapper,
  [`mi-aem-homepage-spa/components/content/utilityNavigation`]: NavigationUtilityLinkWrapper,
  [`mi-aem-homepage-spa/components/content/primaryNavigation`]: NavigationWrapper,
};

export const defineComponentMapping = (allowedComponents, isAuthorMode, pageProps, ppv5CarouselFeatureFlags) => {
  const { carousel_switch_ppv5 = false } = ppv5CarouselFeatureFlags;
  const ppv5CarouselFromLightning =
    (pageProps?.query?.lightning === 'true' || carousel_switch_ppv5 === true) &&
    !pageProps?.requestUri?.includes('/preview');

  MapTo(`mi-aem-offers-spa/components/offers-cards`)(
    props => (
      // Rename to address broken homepage build caused by DXP-7950
      <OfferCardCarousel
        {...props}
        offersData={pageProps.productSpecificResponse ?? []}
        isAuthorMode={isAuthorMode}
        acceptLanguage={pageProps.headersData['accept-language']}
        requestId={pageProps?.requestId}
        cookie={pageProps?.headersData['cookie']}
        isLightning={ppv5CarouselFromLightning}
      />
    ),
    {
      emptyLabel: 'Offers Card Carousel',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-homepage-spa/components/content/universal-footer`)(
    props => <Footer {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'Footer',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/text`)(Text);
  MapTo(`mi-aem-common-spa/components/title`)(Heading);
  MapTo(`mi-aem-common-spa/components/content/cardlayered`)(CardLayered, {
    emptyLabel: 'CardLayered',
    isEmpty: false,
  });
  MapTo(`mi-aem-common-spa/components/common/staticwrapper`)(StaticWrapper, {
    emptyLabel: 'StaticWrapper',
    isEmpty: false,
  });

  MapTo(`mi-aem-ppv5-spa/components/content/localheader`)(
    props => <LocalHeaderEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'LocalHeader',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-ppv5-spa/components/content/hero-banner`)(
    props => <HeroBannerEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'HeroBanner',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-ppv5-spa/components/content/accuWeather`)(
    props => <AccuWeatherEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'AccuWeather',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-ppv5-spa/components/content/internet-box`)(
    props => <InternetBarEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'InternetBarComponent',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-ppv5-spa/components/content/ppv5-rte`)(
    props => <TermsOfUseEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'TermsOfUseComponent',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-ppv5-spa/components/common/staticwrapper`)(
    props => <ConnectContainerEditable {...props} isAuthorMode={isAuthorMode} readyToMount={false} />,
    {
      emptyLabel: 'ConnectContainer',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-ppv5-spa/components/content/brandedcontainer`)(
    props => (
      <PropertyPortalContainerEditable {...props} isAuthorMode={isAuthorMode} isLightning={ppv5CarouselFromLightning} />
    ),
    {
      emptyLabel: 'PropertyPortalContainer',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/cardhorizontalmini`)(
    props => <BonvoyApplicationAdEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'BonvoyApplicationAdComponent',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/bannerlayered`)(
    props => <JoinBannerExperienceEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'JoinBannerExperience',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/mmn-container`)(
    props => <MMNComponentEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'MMNComponent',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-ppv5-spa/components/content/services-carousel`)(
    props => <LocalServicesEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'services_carousel',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-ppv5-spa/components/content/lets-connect-modal`)(
    props => <LetsConnectEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'letsConnect',
      isEmpty: false,
    }
  );

  const ExperienceFragmentVariationConfig = {
    emptyLabel: 'Experience Fragment',

    isEmpty: function (props) {
      return !props || !props.configured;
    },
  };

  MapTo(`mi-aem-ppv5-spa/components/content/experiencefragment`)(props => {
    return (
      <Container
        isInEditor
        {...props}
        isPage={false}
        model={respGridUtil(props?.model)}
        isLightning={ppv5CarouselFromLightning}
      />
    );
  }, ExperienceFragmentVariationConfig);

  MapTo(`mi-aem-homepage-spa/components/content/global-navigation`)(
    props => <NavigationContainerWrapper {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'NavigationContainerWrapper',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-homepage-spa/components/content/utilityNavigation`)(NavigationUtilityLinkWrapper);
  MapTo(`mi-aem-homepage-spa/components/content/primaryNavigation`)(NavigationWrapper);

  const existingMappings = Object.keys(AEM_REACT_MAPPING);
  if (allowedComponents) {
    allowedComponents.forEach(mapping => {
      const baseModelPath = '/jcr:content/root/responsivegrid/';
      const componentPath = mapping.path.split(baseModelPath)[1];

      if (existingMappings.indexOf(componentPath) === -1) {
        MapTo(componentPath)(EditableHTLWrapper, {
          emptyLabel: mapping.title,
          isEmpty: false,
        });
      } else {
        console.log('mapping exists', componentPath);
      }
    });
  }
};
